export default __webpack_public_path__ + "static/media/hospital_selected.0e16245d.svg";